<!--
    Component: MarkdownPublication
    This is a  subcomponent of Publication Component.
    Represent a text in format markdown.
-->
<template>
    <div>
        <v-card-text v-if="markdown_visibility">
            <v-container fluid grid-list-xl>
                <v-layout row wrap>
                    <v-flex>
                        <markdown-viewer :input="data.payload.body"></markdown-viewer>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-flex class="text-xs-right">
                <v-btn @click="changeVisibilityMarkdown">
                    <div v-if="btn_text">
                        <v-icon>pageview</v-icon> {{this.$t('show_message')}}
                    </div>
                    <div v-if="btn_text !== true">
                        <v-icon>pageview</v-icon> {{this.$t('hide_message')}}
                    </div>
                </v-btn>
            </v-flex>
        </v-card-actions>
    </div>
</template>
<script>
    import MarkdownViewer from "../MarkdownViewer";
    export default {
        name: "MarkdownPublication",
        components: {MarkdownViewer},
        props: ['data'],
        data(){
            return {
                markdown_visibility: false,
                btn_text: true
            }
        },
        methods: {
            changeVisibilityMarkdown(){
                this.markdown_visibility = !this.markdown_visibility
                this.btn_text = !this.btn_text
           }
        },
    }
</script>
<style scoped>
</style>
<i18n>
    {
        "en": {
            "show_message": "Show",
            "hide_message": "Hide"
        },
        "es": {
            "show_message": "Ver",
            "hide_message": "Ocultar"
        }
    }
</i18n>
